import { digits, latinLower, latinUpper } from '../constants';
import { getRandom } from './numbers';
export const leadZero = (value, length = 2) => {
    return value.toString().padStart(length, '0');
};
export const getString = (value) => {
    switch (typeof value) {
        case 'number':
        case 'boolean': return value.toString();
        case 'string': return value;
    }
};
export const getRandomChar = (value) => {
    return value[getRandom(0, value.length - 1)];
};
export const upperFirst = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
export const shuffleString = (value) => {
    const array = value.split('');
    const result = array.sort(() => Math.random() - 0.5);
    return result.join('');
};
export const generateUniqueKey = (length = 8) => {
    let result = '';
    const chars = [latinLower, latinUpper, digits].join('');
    for (let index = 0; index < length; index++) {
        result += getRandomChar(chars);
    }
    return result;
};
//# sourceMappingURL=strings.js.map